import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouterOutlet } from '@angular/router';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { FlatpickrModule } from 'angularx-flatpickr';
import { ColorPickerModule, ColorPickerService } from 'ngx-color-picker';
import { ToastrModule } from 'ngx-toastr';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { PhotoGalleryModule } from '@twogate/ngx-photo-gallery'

import { routes } from './app.routes';
import { environment } from '@environments/environment';

import { CustomService } from '@/core/services/custom.serviec';
import { MaterialModuleModule } from '@/material-module/material-module.module';
import { UiModule } from '@/ui/ui.module';
import { ENV_CONFIG } from '@environments/environment-config/environment.interface';
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {httpInterceptorProviders} from "@/core/http-interceptors";
import {DEFAULT_GRAPH_RENDER_CONFIG, GRAPH_RENDER_CONFIG} from "@/core/utilities/graph/graph-config";

// AppConfig is to replace the role that AppModule played in traditional Angular apps.
export const appConfig: ApplicationConfig = {
  // Core behavior of app using functional APIs, rather than traditional NgModules.
  // provideZoneChangeDetection: Optimizes change detection performance.
  providers: [
    {
      provide: ENV_CONFIG,
      useValue: { environment },
    },
    {
      provide: GRAPH_RENDER_CONFIG,
      useValue: {
        ...DEFAULT_GRAPH_RENDER_CONFIG,
        statusColors: { ...DEFAULT_GRAPH_RENDER_CONFIG.statusColors, Failed: '#dc2626' },
      }
    },
    provideHttpClient(withInterceptorsFromDi()),
    httpInterceptorProviders,
    provideRouter(routes),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideCharts(withDefaultRegisterables()),
    RouterOutlet,
    ColorPickerModule,
    MaterialModuleModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireModule,
    ColorPickerService,
    MatTableModule,MatTableDataSource,

    // Import NgModules in this new architecture — it is needed for compatibility with
    // existing NgModule-based libraries. old version
    importProvidersFrom(
      UiModule,
      CustomService,
      FlatpickrModule.forRoot(),
      ToastrModule.forRoot(),
      OverlayscrollbarsModule,
      NgbModule,
      NgCircleProgressModule.forRoot({ }),
      MonacoEditorModule.forRoot(),
      PhotoGalleryModule.forRoot({
        defaultOptions: {
          arrowEl: true,
          indexIndicatorSep: '-'
        }
      }),
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
      AngularFireModule.initializeApp(environment.firebase),
      BrowserAnimationsModule
      ),
  ],
};
